import { useEffect, useState } from "react";
import { Button } from "../../../components/Buttons/Button/Button";
import { useDispatch, useSelector } from "../../../hooks";
import { IQuizTheme } from "../../../redux/quizzes/get-quiz.handler";
import { startQuiz } from "../../../redux/quizzes/start-quiz.handler";
import styles from "./QuizThemesPage.module.scss";
import { PageTitleBlock } from "../../../components/PageTitleBlock/PageTitleBlock";
import { ProfileInfo } from "./ProfileInfo/ProfileInfo";
import { ContentWrapper } from "../../../components/ContentWrapper/ContentWrapper";
import { QuizContext } from "../QuizRoutes";
import { AgeRange, Gender } from "../../../redux/profile";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../components/Menu/MenuButton";
import { TicketsPanel } from "../../../components/TicketsPanel/TicketsPanel";
import { QuizQuestionComplexity } from "../../../redux/quizzes";
import { getTimeLeft } from "../../../utils/time";
import { isQuizAllowedToStart } from "../../../utils/quiz-task";

export const QuizThemesPage = () => {
    const [selectedTheme, setSelectedTheme] = useState<IQuizTheme | null>(null);

    const { themes, ticketsRewards } = useSelector(store => store.quiz);
    const profile = useSelector(store => store.user.profile);
    const quizTask = useSelector(store => store.tasks.quizTask);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectThemeHandler = (theme: IQuizTheme) => setSelectedTheme(theme);

    useEffect(() => {
        if (profile && profile.inited && (profile.gender === Gender.Unknown || profile.ageRange === AgeRange.Unknown))
            navigate(`/${AppContext.Quiz}/${QuizContext.Profile}`, { replace: true });
    }, [navigate, profile]);

    const startHandler = () => {
        if (!selectedTheme || !isQuizAllowedToStart(quizTask?.allowDate))
            return;
        dispatch(startQuiz(selectedTheme.id));
    }

    const canStart = isQuizAllowedToStart(quizTask?.allowDate);

    return (
        <ContentWrapper full={ true } context='quiz'>
            <div className={styles.container}>
                <PageTitleBlock pageTitle={`Участвовать в викторине`} />
                <ProfileInfo />

                <TicketsPanel
                    background={true}
                    { ...ticketsRewards[QuizQuestionComplexity.Expert] }
                    prefix='До +'
                />

                <div className={styles.quizBlock}>
                    <p className={styles.description}>
                        Выбирайте любимую тему и превращайте правильные ответы в монеты и билеты
                    </p>

                    <div className={styles.quizList}>
                        { themes.filter(item => (item === selectedTheme) || !selectedTheme).map((theme) => (
                            <div
                                key={theme.id}
                                className={`${styles.quizItem} ${ selectedTheme === theme ? styles.selected : "" }`}
                                onClick={() => selectThemeHandler(theme)}
                            >
                                <div className={styles.quizInfo}>
                                    <div className={styles.quizTitle}>{theme.name}</div>

                                    <div className={styles.quizDescription}>
                                        { theme.description }
                                    </div>
                                </div>

                                <div className={styles.radioButton} />
                            </div>
                        ))}
                    </div>
                </div>

                { selectedTheme &&
                    <div className={styles.buttons}>
                        { !canStart && quizTask &&
                            <p className={styles.cooldownHint}>
                                Викторина будет доступна через{' '}
                                <span className={styles.waitingTime}>{ getTimeLeft(quizTask.allowDate, -1) }</span>
                            </p>
                        }
                        <Button
                            caption="Начать викторину"
                            handler={ startHandler }
                            disabled={ !canStart }
                        />
                        <Button caption="Выбрать другую тему" type='white' handler={ () => setSelectedTheme(null) } />
                    </div>
                }
            </div>
        </ContentWrapper>
    );
}